import { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

interface PasswordToggleProps {
  onToggle: (isVisible: boolean) => void;
}

const PasswordToggle = ({ onToggle }: PasswordToggleProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleToggle = () => {
    setIsVisible(!isVisible);
    onToggle(!isVisible);
  };

  return (
    <div className="absolute -translate-y-1/2 top-[50%] right-[12px] cursor-pointer z-20">
      {isVisible ? (
        <IoMdEyeOff color="black" size={25} onClick={handleToggle} />
      ) : (
        <IoMdEye color="black" size={25} onClick={handleToggle} />
      )}
    </div>
  );
};
export default PasswordToggle;
